// ============================================================================
// JARVISTRAVEL - A NEW VERSION IS READY (JAR-2323)
// A slim, app-wide strip shown once a deploy has reached this open app. The
// new build is already installed; this page still runs the old one until it
// reloads, so the strip offers that with one tap instead of reloading under
// someone mid-edit. Mounted once at the app root, like the backend banner.
// ============================================================================

import { useSyncExternalStore } from 'react';
import { RefreshCw } from 'lucide-react';
import { isAppUpdateReady, reloadToUpdate, subscribeAppUpdate } from '@/app/utils/appUpdate';

export function UpdateReadyBanner() {
  const ready = useSyncExternalStore(subscribeAppUpdate, isAppUpdateReady, isAppUpdateReady);
  if (!ready) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      // In the normal flow at the app root, so it pushes the page (header and
      // nav included) down instead of covering it, and scrolls off as the page
      // scrolls (JAR-2497). It renders after the backend banner, so when both
      // show the backend strip sits above this one: an unreachable backend
      // matters more.
      className="bg-surface border-b border-accent/40 shadow-sm animate-reveal motion-reduce:animate-none"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="mx-auto w-full max-w-[440px] md:max-w-[960px] flex items-center gap-2.5 px-4 py-2.5">
        <RefreshCw className="w-4 h-4 shrink-0 text-accent" strokeWidth={2} aria-hidden="true" />
        <p className="flex-1 min-w-0 text-sm leading-tight font-semibold text-ink">
          A new version of JarvisTravel is ready.
        </p>
        <button
          onClick={reloadToUpdate}
          className="shrink-0 rounded-lg bg-accent/15 px-3 py-1.5 text-sm font-semibold text-accent hover:bg-accent/25 transition-colors"
        >
          Reload
        </button>
      </div>
    </div>
  );
}

export default UpdateReadyBanner;
